module.exports = __webpack_public_path__ + "img/team-member-1.d2be9830.png";